import { render, staticRenderFns } from "./CourseBook.vue?vue&type=template&id=4a4bbef7&scoped=true&"
import script from "./CourseBook.vue?vue&type=script&lang=ts&"
export * from "./CourseBook.vue?vue&type=script&lang=ts&"
import style0 from "./CourseBook.vue?vue&type=style&index=0&id=4a4bbef7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bbef7",
  null
  
)

export default component.exports